import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { SuperAdminService } from "src/app/super-admin.service";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { NgxSpinnerService } from "ngx-spinner";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { InvoiceTrackerPreviewComponent } from "../invoice-tracker-preview/invoice-tracker-preview.component";

@Component({
  selector: "app-tracker-invoice-list",
  templateUrl: "./tracker-invoice-list.component.html",
  styleUrls: ["./tracker-invoice-list.component.css"],
})
export class TrackerInvoiceListComponent implements OnInit {
  clientList: any[] = [];
  trackerNumber: any[] = [];
  invoiceType: any[] = [];
  invoiceList: any[] = [];
  dataSource: MatTableDataSource<any>;

  invtot: any;
  tooltaxPaidtot: any;
  extrahour: any;
  kmtot: any;

  users: any[] = [];
  paramId: string;
  billno: string = '';
  invoiceDate: string = '';
  invoiceMonth: string = '';
  showFixedRateTable: boolean = false;

  displayedColumns = ["sno", "billNo", "clientName", "created_date", "action"];

  dropdownSettings = {
    singleSelection: false,
    idField: "item_id",
    textField: "item_text",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
  };

  filterform = new FormGroup({
    clientName: new FormControl("", Validators.required),
    invoiceType: new FormControl("", Validators.required),
    Tracker_no: new FormControl("", Validators.required),
  });

  @ViewChild("printBtn") printBtn: ElementRef<HTMLElement>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild("printSection") printSection!: ElementRef<HTMLDivElement>;



  private invoiceTrackerPreviewRef: MatDialogRef<InvoiceTrackerPreviewComponent>;

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private superAdminService: SuperAdminService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.getClientList();
    this.getInvoiceTypes();
    this.getTrackerInvoices();
  }

  private handleAuthOrError(message: string, status: number): void {
    this.spinner.hide();
    if (status === 401) {
      this.toastr.error(message);
      sessionStorage.clear();
      this.router.navigateByUrl("superAuth/login");
    } else {
      this.toastr.error(message);
    }
  }

  getTrackerInvoices() {
    this.superAdminService.getTrackerInvoiceNew().subscribe((res) => {
      if (res.status) {
        this.invoiceList = res.data;
        this.dataSource = new MatTableDataSource(this.invoiceList);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    });
  }

  onClientChange(event: any) {
    const clientId = event.target.value;
    this.superAdminService.getTrackersByClientId(clientId).subscribe((res) => {
      if (res.status) {
        this.trackerNumber = res.data.map((x, i) => ({
          item_id: i,
          item_text: x.Tracker_no,
        }));
      }
    });
  }

  generateTrackerInvoice(billNo: string): void {
    if (!this.filterform.valid) {
      this.toastr.error("Please fill all required fields");
      return;
    }

    const selectedTrackers = Array.isArray(this.filterform.value.Tracker_no)
      ? this.filterform.value.Tracker_no.map((item: any) => item.item_text)
      : [];

    if (!selectedTrackers.length) {
      this.toastr.error("Please select at least one Tracker");
      return;
    }

    const payload = {
      billNo,
      clientId: this.filterform.value.clientName,
      invoiceType: this.filterform.value.invoiceType,
      trackerNos: selectedTrackers,
    };

    this.spinner.show();

    this.superAdminService.generateTrackerInvoice(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          this.toastr.success(res.message);
          this.getTrackerInvoices();
          this.filterform.reset();
          this.trackerNumber = [];
        } else {
          this.toastr.error(res.message);
        }
      },
      () => {
        this.spinner.hide();
        this.toastr.error("Something went wrong");
      }
    );
  }


  generateTrackerInvoicePreview(): void {
    if (!this.filterform.valid) {
      this.toastr.error("Please fill all required fields");
      return;
    }

    const selectedTrackers = Array.isArray(this.filterform.value.Tracker_no)
      ? this.filterform.value.Tracker_no.map((item: any) => item.item_text)
      : [];

    if (!selectedTrackers.length) {
      this.toastr.error("Please select at least one Tracker");
      return;
    }

    const payload = {
      clientId: this.filterform.value.clientName,
      invoiceType: this.filterform.value.invoiceType,
      trackerNos: selectedTrackers,
    };

    this.spinner.show();

    this.superAdminService.generateTrackerInvoicePreview(payload).subscribe(
      (res) => {
        this.spinner.hide();
        // this.spinner.hide();
        // if (res.status) {
        //   this.toastr.success(res.message);
        //   this.getTrackerInvoices();
        //   this.filterform.reset();
        //   this.trackerNumber = [];
        // } else {
        //   this.toastr.error(res.message);
        // }

        if (res.status) {
          this.invoiceTrackerPreviewRef = this.dialog.open(InvoiceTrackerPreviewComponent, {
            data: res.data,
            disableClose: true,
            width: '67%',
            height: 'auto',
            maxHeight: '90vh',
            panelClass: 'custom-border-radius'
          });

          this.invoiceTrackerPreviewRef.afterClosed().subscribe((result: { status: "approved" | "declined", billno?: string }) => {

            if ("status" in result) {
              if (result.status == "approved") {
                this.generateTrackerInvoice(result.billno)
                // this.generateInvoice(result.billno)
                // this.toastr.success("Invoice approved successfully");

              } else {
                this.filterform.reset()
                this.trackerNumber = []
                this.toastr.error("Invoice declined");
              }
            }
          },
            () => {
              this.spinner.hide();
              this.toastr.error("Something went wrong");
            }
          );
        }
      }
    );
  }


  getParticularInvoice(id: string) {
    this.paramId = id;
    this.spinner.show();

    this.superAdminService.getParticularInvoice(id).subscribe(
      (res: any) => {
        this.spinner.hide();

        if (!res.status) {
          this.toastr.error(res.message);
          return;
        }

        const invoice = res.data?.[0]?.invoice || [];
        this.billno = res.data?.[0]?.billno || res.data?.[0]?.billNo || '';
        this.invoiceDate = this.formatDate(res.data?.[0]?.createdAt);
        this.invoiceMonth = this.formatMonth(res.data?.[0]?.createdAt);
        this.users = invoice;

        const invoiceType = res.data?.[0]?.invoiceType || res.data?.[0]?.invoice?.[0]?.invoiceTypeName?.[0] || '';
        const isFixedRate = invoiceType?.trim() === 'Fixed Rate Invoice' || invoiceType?.trim() === 'Monthly Fixed Invoice';
        this.showFixedRateTable = isFixedRate;

        if (invoice.length) {
          this.invtot = 0;
          this.kmtot = 0;
          this.extrahour = 0;
          this.tooltaxPaidtot = 0;

          this.users.forEach((user: any) => {
            this.invtot += (user.vehicleRate || []).reduce((a: number, b: any) => a + Number(b || 0), 0);
            this.kmtot += (user.up_down_km || []).reduce((a: number, b: any) => a + Number(b || 0), 0);
            this.extrahour += (user.extrahour || []).reduce((a: number, b: any) => a + Number(b || 0), 0);
            this.tooltaxPaidtot += (user.tooltaxPaid || []).reduce((a: number, b: any) => a + Number(b || 0), 0);
          });
        }

        setTimeout(() => {
          this.printBtn?.nativeElement?.click();
        }, 300);
      },
      () => {
        this.spinner.hide();
        this.toastr.error("Failed to load invoice");
      }
    );
  }

  deleteTrackerInvoice(id: string) {
    console.warn("TODO: deleteTrackerInvoice()", id);
  }

  viewTrackerInvoice(id: string): void {
    this.router.navigate(["/superAdmin/lrmanagement/tracker-invoice/view", id]);
  }

  getClientList(): void {
    this.superAdminService.getClientList().subscribe(
      (res: any) => {
        if (!res.status) {
          this.handleAuthOrError(res.message, res.status);
          return;
        }

        let clients = res.data || [];
        const userSessionData = JSON.parse(
          sessionStorage.getItem("userSession")
        );

        const userRoleId = userSessionData?.user_role_id?.[0];

        if (userRoleId !== 1 && Array.isArray(userSessionData?.clientList)) {
          clients = clients.filter((client) =>
            userSessionData.clientList.includes(client.clientEmail)
          );
        }

        this.clientList = clients;
      },
      () => this.toastr.error("Failed to load clients")
    );
  }

  getInvoiceTypes() {
    this.superAdminService.getInvoiceTypes().subscribe((res: any) => {
      if (res.status) {
        // this.invoiceType = res.data;
        this.invoiceType = [
          {
            "invoiceTypeName": "Type 1",
            "value": "Fixed Rate Invoice"
          }
        ]
      } else {
        this.handleAuthOrError(res.message, res.status);
      }
    });
  }

  sendInvoice(divName: string, Id: string) {
    this.paramId = Id;
    this.superAdminService.getParticularInvoice(Id).subscribe(
      (res: any) => {
        if (res.status === true) {
          var rawdata = res.data;
          this.billno = rawdata[0]?.billno || rawdata[0]?.billNo || '';
          this.users = rawdata[0].invoice;

          this.invtot = 0;
          this.kmtot = 0;
          this.extrahour = 0;
          this.tooltaxPaidtot = 0;

          this.users.forEach((user: any) => {
            this.invtot += (user.vehicleRate || []).reduce((a: number, b: any) => a + Number(b || 0), 0);
            this.kmtot += (user.up_down_km || []).reduce((a: number, b: any) => a + Number(b || 0), 0);
            this.extrahour += (user.extrahour || []).reduce((a: number, b: any) => a + Number(b || 0), 0);
            this.tooltaxPaidtot += (user.tooltaxPaid || []).reduce((a: number, b: any) => a + Number(b || 0), 0);
          });

          // send invoice begins
          setTimeout(() => {
            var data = document.getElementById(divName);
            data.style.display = "block";
            html2canvas(data).then((canvas) => {
              var imgWidth = 208;
              var imgHeight = (canvas.height * imgWidth) / canvas.width;
              const contentDataURL = canvas.toDataURL("image/png", 0.3);
              let pdf = new jsPDF("p", "mm", "a4");
              pdf.addImage(
                contentDataURL,
                "PNG",
                1,
                1,
                imgWidth,
                imgHeight,
                undefined,
                "FAST"
              );
              let binary = pdf.output();
              data.style.display = "none";
              binary = binary ? btoa(binary) : "";
              this.superAdminService.sendInvoice(Id, binary).subscribe(
                (res: any) => {
                  if (res.status == true) {
                    this.toastr.success(res.message);
                  } else {
                    if (res.status == 401) {
                      this.toastr.error(res.message);
                      window.sessionStorage.clear();
                      this.router.navigateByUrl("superAuth/login");
                    } else {
                      this.toastr.error(res.message);
                    }
                  }
                },
                (error) => { }
              );
            });
          });
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.success(res.message);
          }
        }
      },
      (error) => { }
    );
  }

  backTo() {
    window.history.back();
  }

  filterData(value: string) {
    this.dataSource.filter = value.trim().toLowerCase();
  }

  getDisplayValue(value: any): string {
    if (value === null || value === undefined || value === '') return '-';
    return value;
  }

  getTopDisplayValue(value: any): string {
    if (value === null || value === undefined || value === '') return 'N/A';
    return value;
  }

  getActualWorkingDays(startDate: any, endDate: any): any {
    if (!startDate || !endDate) return '-';
    const start = new Date(startDate);
    const end = new Date(endDate);
    if (isNaN(start.getTime()) || isNaN(end.getTime())) return '-';
    const diffTime = Math.abs(end.getTime() - start.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays === 0 ? 1 : diffDays;
  }

  private getNum(value: any): number {
    if (value === null || value === undefined || value === '') return 0;
    const num = Number(value);
    return isNaN(num) ? 0 : num;
  }

  getExtraKmVal(user: any, i: number): number {
    const totalKm = this.getNum(user.up_down_km?.[i]);
    const fixedKm = this.getNum(user.fixedKM?.[i]);
    return Math.max(0, totalKm - fixedKm);
  }

  getAmountForKm(user: any, i: number): number {
    return this.getExtraKmVal(user, i) * this.getNum(user.extraKMCost?.[i]);
  }

  getAmountForExtraHrs(user: any, i: number): number {
    return this.getNum(user.extrahour?.[i]) * this.getNum(user.variableCostHr?.[i]);
  }

  getRowTotalAmount(user: any, i: number): number {
    const A = this.getNum(user.fixedPaymentMonth?.[i]);
    const B = this.getAmountForKm(user, i);
    const C = this.getAmountForExtraHrs(user, i);
    const D = this.getNum(user.tooltaxPaid?.[i]);
    const E = this.getNum(user.otherPayment?.[i]);
    return A + B + C + D + E;
  }

  getGrandTotal(users: any[]): number {
    if (!users?.length) return 0;
    let total = 0;
    for (const user of users) {
      if (user.vehicle_id) {
        for (let i = 0; i < user.vehicle_id.length; i++) {
          total += this.getRowTotalAmount(user, i);
        }
      }
    }
    return total;
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return 'N/A';
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return 'N/A';
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yy = String(d.getFullYear()).slice(-2);
    return `${dd}/${mm}/${yy}`;
  }

  formatMonth(dateStr: string): string {
    if (!dateStr) return 'N/A';
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return 'N/A';
    return d.toLocaleString('en-US', { month: 'long' });
  }
}
